<template>
  <div v-if="value?.length">
    <div
      v-for="(placementStatus, index) in value"
      :key="index"
      class="my-5 max-w-40 break-normal whitespace-nowrap"
    >
      <placement-status-dropdown
        :status="placementStatuses[placementStatus] || '-'"
        view-only
      />
    </div>
  </div>
  <div v-else>-</div>
</template>
<script lang="ts" setup>
import { type PropType, computed } from "vue";
import { useStore } from "vuex";

import PlacementStatusDropdown from "@/components/deals/PlacementStatusDropdown.vue";

defineProps({
  value: {
    type: Array as PropType<number[]>,
  },
});

const { getters } = useStore();
const placementStatuses = computed(
  () => getters["options/all"]["placement"]["statuses"]
);
</script>
